import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { ImageUploadField } from "@/components/admin/ImageUploadField";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

const inputCls = "bg-cream border-olive/40 focus-visible:ring-burgundy text-charcoal";

export const ProductFormDialog = ({ open, onOpenChange, form, setForm, editing, saving, onSave }) => {
  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="product-dialog" className="bg-cream border-olive/40 max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display text-charcoal text-2xl">
            {editing ? "Edit Product" : "Add Product"}
          </DialogTitle>
          <DialogDescription className="text-charcoal/60 font-body">
            Manage an Amazon affiliate product shown on your storefront.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <div>
            <Label className="text-charcoal/70">Title</Label>
            <Input data-testid="product-title-input" className={inputCls} value={form.title} onChange={update("title")} />
          </div>
          <div>
            <Label className="text-charcoal/70">Description</Label>
            <Textarea data-testid="product-description-input" className={inputCls} value={form.description} onChange={update("description")} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-charcoal/70">Price</Label>
              <Input data-testid="product-price-input" className={inputCls} placeholder="$24.00" value={form.price} onChange={update("price")} />
            </div>
            <div>
              <Label className="text-charcoal/70">Category</Label>
              <Input data-testid="product-category-input" className={inputCls} placeholder="Beauty / Home / Style" value={form.category} onChange={update("category")} />
            </div>
          </div>
          <ImageUploadField
            label="Product Image"
            testid="product-image"
            value={form.image_url}
            onChange={(url) => setForm({ ...form, image_url: url })}
          />
          <div>
            <Label className="text-charcoal/70">Amazon Link</Label>
            <Input data-testid="product-amazon-input" className={inputCls} value={form.amazon_url} onChange={update("amazon_url")} />
          </div>
          <div className="flex items-center gap-3">
            <Switch data-testid="product-featured-switch" checked={form.featured} onCheckedChange={(v) => setForm({ ...form, featured: v })} />
            <Label className="text-charcoal/70">Mark as Favorite</Label>
          </div>
        </div>
        <DialogFooter className="mt-4">
          <Button variant="outline" className="rounded-none border-charcoal/40 text-charcoal" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="save-product-button" disabled={saving} className="bg-maroon hover:bg-burgundy text-cream rounded-none" onClick={onSave}>
            {saving ? "Saving…" : "Save Product"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
